
      import '@folkjs/labs/standalone/folk-shape';
      import '@folkjs/labs/standalone/folk-sand-webgpu';

      document.querySelector('folk-sand-webgpu').onMaterialChange = (materialNumber) => {
        document.querySelector('key-helper button[active]').removeAttribute('active');
        document.querySelector(`key-helper button:nth-child(${materialNumber})`).setAttribute('active', '');
      };
    